export const MODAL_TYPE_DELETE_CATEGORY = 'delete-category';
